import { useMutation } from '@tanstack/react-query';

import { requestSignature, type RequestSignaturePayload } from '@services/document-signer/document-signer.service';

export function useRequestSignature(accessToken: string) {
  return useMutation({
    mutationFn: (payload: RequestSignaturePayload) => requestSignature(payload, accessToken),
  });
}
